import type { ApiResponse, InstructionPayload } from '@/store/types'
import { decodeInstruction, type Instruction } from '@/backend/schema/instruction'
import { get } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'

/**
 * Load AI assisted review instructions from backend
 */
export const loadInstructions = async (params: {
  team_slug: string
}): Promise<ApiResponse<{ instructions: Instruction[] }> | ParsedError> => {
  const { team_slug, ...rest } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions`

  try {
    const response = await get<{ instructions: InstructionPayload[] }>(path, rest, {
      arrayFormat: 'brackets',
    })

    return {
      data: {
        instructions: response.data.instructions.map(decodeInstruction),
      },
    }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_LOAD)
  }
}
